export default __webpack_public_path__ + "static/media/OpenSans-Italic.dcb5386a.ttf";